import {
  SurveyDescriptionChangedChange,
  SurveyLevelDangerousChange,
  SurveyNameChangedChange,
  SurveyCrmSystemChangedChange,
} from "../../types/syncCheckResult";

export const isSurveyNameChangedChange = (
  change: SurveyLevelDangerousChange
): change is SurveyNameChangedChange => {
  return change.type === "SURVEY_NAME_CHANGED";
};

export const isSurveyDescriptionChangedChange = (
  change: SurveyLevelDangerousChange
): change is SurveyDescriptionChangedChange => {
  return change.type === "SURVEY_DESCRIPTION_CHANGED";
};

export const isSurveyCrmSystemChangedChange = (
  change: SurveyLevelDangerousChange
): change is SurveyCrmSystemChangedChange => {
  return change.type === "SURVEY_CRM_SYSTEM_CHANGED";
};